import { ReachAPI } from '../../ReachApi';
import { z } from 'zod';
import { forceTypingDeferred, getSecurityIdentity } from '../core';

type Scores = {
    get: (
        widget_id: number,
        security: ReachAPI.Security,
        timezone: string
    ) => JQueryDeferred<unknown>;
};

const scoresDataSchema = z.object({
    /** Url to team logo */
    awaylogo: z.string(),
    /** @todo what type is this prop when present? */
    awayscore: z.union([z.string(), z.number()]).nullish(),
    awayteam: z.string(),
    /** Ex: 'NYM' */
    awayteamid: z.string(),
    gameid: z.union([z.string(), z.number()]),
    /** Url to team logo */
    homelogo: z.string(),
    /** @todo what type is this prop when present? */
    homescore: z.union([z.string(), z.number()]).nullish(),
    hometeam: z.string(),
    /** Ex: 'MIA' */
    hometeamid: z.string(),
    /** Ex: 'MLB' */
    league: z.string(),

    /**
     * Ex: '7:30 pm, ET'
     * Seems like an empty string is also used instead of null
     */
    status: z.string(),
});

const scoresDataApiResponseSchema = z.object({
    feed: z.array(scoresDataSchema),
});

/**
 * GET Endpoint `/scores`
 * @throws {@link ReachApiRetrievalError}
 */
export const getScores = function (
    widgetId: number,
    timezone: string
): Promise<z.infer<typeof scoresDataApiResponseSchema>> {
    return forceTypingDeferred(
        scoresDataApiResponseSchema,
        (ReachAPI.scores as Scores).get(widgetId, getSecurityIdentity(), timezone)
    );
};
